import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type { ApiAsset } from "../_types/assets.types";

export const useUploadAssetMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: { file: File; name?: string }) => {
      const form = new FormData();
      form.append("file", payload.file);
      form.append("name", payload.name?.trim() || payload.file.name);
      const response = await axiosInstance.post<ApiResponse<ApiAsset>>(
        "/v2/assets",
        form,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );
      if (!response.data.success || !response.data.data) {
        throw new Error(response.data.message ?? "Upload failed");
      }
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["assets"] });
    },
  });
};
